"use client";

import "@kalkulacka-one/design-system/themes/www.volebnikalkulacka.cz/diky-ze-muzem.css";

export const DikyZeMuzemTheme = ({ children }: { children: React.ReactNode }) => {
  return children;
};
